import React from 'react';
import ChartIcon from '@/assets/icons/Monitoring/ChartIcon.svg?react';
import TableIcon from '@/assets/icons/Monitoring/TableIcon.svg?react';
import { Button } from '@/components/atoms/PcButton';
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/atoms/PcTooltip';

type TableChartToggleProps = {
  toggle: 'table' | 'chart';
  setToggle: (value: 'table' | 'chart') => void;
};

const TableChartToggle: React.FC<TableChartToggleProps> = ({ toggle, setToggle }) => {
  return (
    <TooltipProvider>
      <div className="flex items-center gap-1">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className={`h-[34px] w-[34px] p-[7px] shadow-none transition-opacity ${
                toggle === 'table' ? 'cursor-default opacity-40' : ''
              }`}
              tabIndex={toggle === 'table' ? -1 : 0}
              aria-disabled={toggle === 'table'}
              aria-pressed={toggle === 'table'}
              onClick={() => {
                if (toggle === 'table') return;
                setToggle('table');
              }}
            >
              <TableIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="top" align="center">
            테이블 보기
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className={`h-[34px] w-[34px] p-[7px] shadow-none transition-opacity ${
                toggle === 'chart' ? 'cursor-default opacity-40' : ''
              }`}
              tabIndex={toggle === 'chart' ? -1 : 0}
              aria-disabled={toggle === 'chart'}
              aria-pressed={toggle === 'chart'}
              onClick={() => {
                if (toggle === 'chart') return;
                setToggle('chart');
              }}
            >
              <ChartIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="top" align="center">
            차트 보기
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};

export default TableChartToggle;
